import * as React from 'react';
import { Badge } from 'antd';
import { isString } from 'util';
import { isEqual } from 'lodash';

import defaultUrl from '../../assets/default.png';
import styles from './index.less';

export type ImageItem =
  | string
  | {
      url: string;
      name: string;
    };
export const getUrl = (v: ImageItem) => (isString(v) ? v : v.url);

const defaultProps = {
  size: 30, // 图片大小
  images: [] as ImageItem[], // 图片组
};
const initialState = {
  images: [] as ImageItem[],
};

type DefaultProps = typeof defaultProps;
type Props = DefaultProps & {
  imageProps?: React.ImgHTMLAttributes<HTMLImageElement>;
} & React.DOMAttributes<HTMLAnchorElement>;
type State = Readonly<typeof initialState>;

const themeColor = process.env.THEME_COLOR;
class ImageCmp extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      images: [...props.images],
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (
      !isEqual(prevProps.images, this.props.images) &&
      !isEqual(this.state.images, this.props.images)
    ) {
      this.setState({ images: [...this.props.images] });
    }
  }
  render() {
    const { size, imageProps } = this.props;
    const { images } = this.state;
    const cloneImages = images.slice(0, 2);

    if (!images.length) {
      images.push(defaultUrl);
    }
    return (
      <Badge
        style={{
          height: 14,
          lineHeight: '14px',
          backgroundColor: themeColor,
        }}
        count={images.length > 1 ? images.length : 0}
      >
        <div style={{ position: 'relative', left: 5 - cloneImages.length * 5 }}>
          {cloneImages.map((v, idx) => (
            <div
              key={JSON.stringify(v) + idx}
              className={styles.thumbnail}
              style={{
                width: size,
                height: size,
                top: idx * 5,
                left: idx * 5,
                zIndex: idx,
              }}
            >
              <img
                width={size}
                height={size}
                src={getUrl(v)}
                alt={(isString(v) ? v : v.name) || '图片'}
                onError={this.handleError(idx)}
                style={{ objectFit: 'cover' }}
                {...imageProps}
              />
            </div>
          ))}
        </div>
      </Badge>
    );
  }
  handleError = (i: number) => {
    return () => {
      const { images } = this.state;
      if (images.includes(defaultUrl)) {
        images.splice(i, 1);
      } else {
        images.splice(i, 1, defaultUrl);
      }
      this.setState({ images: [...images] });
    };
  };
}

export default ImageCmp;
